// A2F-650: single custom-rule card for Step 4.
//
// Status drives the icon background tint — purple for active rules
// (the wireframe spec) and slate for coming_soon, since the LLM
// couldn't translate the request and we want to surface that
// uncertainty visually.

import { X } from 'lucide-react'

interface RuleCardProps {
  iconLetter: string
  name: string
  description: string
  status: 'active' | 'coming_soon' | 'example'
  onRemove?: () => void
}

export function RuleCard({
  iconLetter,
  name,
  description,
  status,
  onRemove,
}: RuleCardProps) {
  const iconBg =
    status === 'coming_soon'
      ? 'bg-slate-100 text-slate-500'
      : 'bg-violet-50 text-violet-700'
  const cardOpacity = status === 'example' ? 'opacity-70' : ''
  return (
    <div
      className={`flex items-center gap-3 bg-brand-canvas rounded-lg border border-slate-200 px-3.5 py-2.5 mb-2 ${cardOpacity}`}
    >
      <div
        className={`grid place-items-center h-6 w-6 rounded-md text-xs font-semibold shrink-0 ${iconBg}`}
      >
        {iconLetter}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[12px] font-medium text-brand-charcoal truncate">
          {name}
        </div>
        <div className="text-[11px] text-slate-500 truncate">{description}</div>
      </div>
      {status === 'example' ? (
        <span className="text-[9px] font-semibold uppercase tracking-wider rounded px-1.5 py-0.5 bg-slate-100 text-slate-500">
          Example
        </span>
      ) : (
        <span className="text-[9px] font-semibold uppercase tracking-wider rounded px-1.5 py-0.5 bg-brand-orange/10 text-brand-orange">
          {status === 'coming_soon' ? 'Soon' : 'Pro'}
        </span>
      )}
      {onRemove ? (
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Remove ${name}`}
          className="grid place-items-center h-5 w-5 rounded text-slate-400 hover:text-slate-600 hover:bg-slate-100 shrink-0"
        >
          <X size={12} strokeWidth={2.5} />
        </button>
      ) : null}
    </div>
  )
}
